export function deepCopy<T>(o: T): T {
    return JSON.parse(JSON.stringify(o));
}

export function deepEqual<T>(a: T, b: T): boolean {
    return JSON.stringify(a) === JSON.stringify(b);
}